import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import downloadJsonFile from '@/utils/general/fileDownload/downloadJsonFile';
import { getExportedNetwork } from '@/utils/network/export/getExportedNetwork';
import { mutationWithFeedback } from '@/utils/toast';
import { trpc } from '@/utils/trpc';
import getNetworkName from '../utils/getNetworkName';
function useExportReleaseNetwork() {
  const $ = _c(2);
  const trpcUtils = trpc.useUtils();
  let t0;
  if ($[0] !== trpcUtils) {
    t0 = async (networkId, networks) => {
      const exportedNetwork = await mutationWithFeedback({
        mutation: getExportedNetwork(trpcUtils, networkId),
        successText: "Network exported",
        errorText: "Failed to export network",
        loadingText: "Exporting..."
      });
      const networkName = getNetworkName(networks, networkId);
      downloadJsonFile({
        name: networkName,
        ...exportedNetwork
      }, `release_export__${networkName.replaceAll(" ", "_")}.json`);
      return exportedNetwork;
    };
    $[0] = trpcUtils;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default useExportReleaseNetwork;